import ManagementsDetail from "../../components/Managements/ManagementsDetail/ManagementsDetail";

const ManagementsDetailPage = () => {
  return <ManagementsDetail />;
};

export default ManagementsDetailPage;
